import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Upload, Icon, message, Select, Button } from 'antd'
import moment from 'moment'
import { users } from '@services/api'

@inject((store: any) => {
    const { popupStore } = store

    return {
        popupStore
    }
})
@observer
export default class ChooseFilePopup extends Component<any, any> {
    state: any = {
        selectedFile: ''
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    handleSelectedFile = e => {
        this.setState({ selectedFile: e })
    }

    reloadCases = async () => {
        const { docFiles } = this.props.popupStore.info
        const { selectedFile } = this.state
        const file = docFiles.find(docFile => docFile.file_name === selectedFile)
        if (file) {
            this.closePopup()
            await users.updateHarbCases({ user_id: file.related_id, file_id: file.id })
            this.props.refreshInsuranceCases()
        }
    }

    render() {
        const { popupStore } = this.props

        const footerButtons = (
            <Fragment>
                <Button onClick={() => this.closePopup()}>סגור</Button>
                <Button type="primary" onClick={() => this.reloadCases()}>
                    רענן תיק ביטוחי
                </Button>
            </Fragment>
        )

        return (
            <Modal
                title="בחירת תיק ביטוחי"
                visible={popupStore.popupType === 'chooseFile'}
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                {popupStore.info.docFiles && popupStore.info.docFiles.length > 0 ? (
                    <Select
                        style={{ width: '100%' }}
                        placeholder="בחר תיק ביטוחי"
                        value={this.state.selectedFile}
                        onChange={e => this.handleSelectedFile(e)}
                    >
                        {popupStore.info.docFiles.map(docFile => (
                            <Select.Option key={docFile.id} value={docFile.file_name}>
                                <span>{docFile.file_name} </span>
                                <span>נוצר בתאריך: {moment(docFile.created_at).format('DD/MM/YYYY HH:mm')}</span>
                                <div>{!docFile.updated_by && 'הקובץ המקורי'}</div>
                            </Select.Option>
                        ))}
                    </Select>
                ) : (
                    ''
                )}
            </Modal>
        )
    }
}
